export default __webpack_public_path__ + "static/media/whaletogether-mock.4296a235.jpg";